export default {
  modules_chars_counter() {
    return {
      charsCounter: {
        el: this.el.closest("form").querySelector(".rich-text-max-length"),
        maxChars: Number(this.el.dataset["maxChars"]),
      },
    }
  },
}
